module.exports = __webpack_public_path__ + "img/email.d5fbde7a.svg";